import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-brands_form_email_address-click';

/**
 * Focus on the email address field in brands sign up form. This event may be less comment since the email address can be pre-filled.
 */
export function trackBrandLeadsBrandsFormEmailAddressClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
